// extracted by mini-css-extract-plugin
module.exports = {"card":"Ui_card__3Uv80","cardInner":"Ui_cardInner__12Xfn"};